 export const customSelectStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: '#EBEDF9',
      border: '1px solid #e0e0e0',
      borderRadius: '0.375rem',
      padding: '0.5rem 0',
      fontSize: '1rem',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#d0d0d0'
      },
      '&:focus': {
        borderColor: '#0066cc',
        boxShadow: '0 0 0 3px rgba(0, 102, 204, 0.1)'
      }
    }),
    input: (base: any) => ({
      ...base,
      color: '#333',
      padding: '0 0.5rem'
    }),
    placeholder: (base: any) => ({
      ...base,
      color: '#999'
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? '#0066cc' : state.isFocused ? '#f0f4f8' : '#fff',
      color: state.isSelected ? '#fff' : '#333',
      padding: '0.75rem 1rem',
      cursor: 'pointer'
    }),
    menuList: (base: any) => ({
      ...base,
      maxHeight: '250px'
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999
    })
  };
